/**
 * Vivre Control Plane — Sidenav Collapse Styles
 * Active: semi-transparent white bg (#ffffffb8), dark navy text
 * Inactive: white text, transparent bg
 * Font: 14px, 700 weight (Open Sans)
 */

function collapseItem(theme, ownerState) {
  const { transitions, breakpoints, borders, functions } = theme;
  const { active } = ownerState;

  const { borderRadius } = borders;
  const { pxToRem, rgba } = functions;

  return {
    // Active: semi-transparent white pill, Inactive: transparent
    background: active ? "rgba(255, 255, 255, 0.72)" : "transparent",
    // Active: dark navy text, Inactive: white text
    color: active ? "#141D46" : "#FFFFFF",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(9)} ${pxToRem(16)}`,
    margin: `${pxToRem(2)} ${pxToRem(12)}`,
    // Pill shape with rounded left corners
    borderRadius: pxToRem(8),
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active ? "0 2px 8px rgba(0,0,0,0.08)" : "none",

    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: active
        ? "rgba(255, 255, 255, 0.72)"
        : "rgba(255, 255, 255, 0.12)",
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { transitions, borders, functions } = theme;
  const { active } = ownerState;

  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(32),
    minHeight: pxToRem(32),
    color: active ? "#141D46" : "#FFFFFF",
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: active ? "#141D46" : "#FFFFFF",
    },
  };
}

const collapseIcon = (theme, { active }) => ({
  color: active ? "#141D46" : "#FFFFFF",
});

function collapseText(theme, ownerState) {
  const { transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(10),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(10),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: 800,
      fontSize: "14px",
      lineHeight: 0,
      fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      letterSpacing: "0.2px",
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
